import FlashContext from "components/FlashMessages/FlashContext";
import { ArrowCircle } from "components/icons/generated";
import Button, { ButtonProps } from "ds/components/Button";
import Tooltip from "ds/components/Tooltip";
import useTypedContext from "hooks/useTypedContext";
import useCanSyncCommit from "shared/Stack/access/useCanSyncCommit";
import useStackSyncCommit from "shared/Stack/useSyncCommit";
import { StackContext } from "views/Stack/Context";

type SyncButtonProps = {
  size?: ButtonProps["size"];
  variant?: ButtonProps["variant"];
};

const SyncButton = ({ size, variant = "secondary" }: SyncButtonProps) => {
  const { stack } = useTypedContext(StackContext);
  const { reportSuccess } = useTypedContext(FlashContext);

  const [syncStackCommit, { loading }] = useStackSyncCommit();

  const handleClick = () =>
    syncStackCommit({ id: stack.id }, (data) => {
      if (data?.stackSyncCommit) {
        reportSuccess({ message: "Tracked commit successfully synced" });
      }
    });

  const canSyncCommit = useCanSyncCommit()(stack);

  if (!canSyncCommit.result && !canSyncCommit.message) return null;

  return (
    <Tooltip
      on={(props) => (
        <Button
          {...props}
          size={size}
          variant={variant}
          onPress={handleClick}
          startIcon={ArrowCircle}
          disabled={loading || !canSyncCommit.result}
        >
          Sync
        </Button>
      )}
    >
      {canSyncCommit.message || "Synchronize tracked commit with head branch."}
    </Tooltip>
  );
};

export default SyncButton;
